import {openModal} from '../Actions'
import EditPostModal from './';

export const openEditPostModal = post => openModal(EditPostModal, {post});

